// `weba` is not a typo: the backend validates the extension it guesses from the
// file, and Symfony maps `audio/webm` — what Chrome records — to `weba`.
export const ASSISTANT_AUDIO_EXTENSIONS = [
    'webm',
    'weba',
    'mp4',
    'm4a',
    'ogg',
    'wav',
]

export const ASSISTANT_AUDIO_MIME_TO_EXTENSION = {
    'audio/webm': 'webm',
    'audio/ogg': 'ogg',
    'audio/mp4': 'm4a',
    'audio/x-m4a': 'm4a',
    'audio/wav': 'wav',
    'audio/wave': 'wav',
    'audio/x-wav': 'wav',
}

export const ASSISTANT_AUDIO_MAX_SIZE = 25 * 1024 * 1024

export const ASSISTANT_TEXT_MAX_LENGTH = 4000

// `awaiting_answer` means there is no card yet. `open` means the card exists —
// not that the conversation is over: a question can still be in the reply.
export const ASSISTANT_STATES = {
    OPEN: 'open',
    AWAITING_ANSWER: 'awaiting_answer',
    AWAITING_CONFIRMATION: 'awaiting_confirmation',
}

export const ASSISTANT_CONFIRM_TYPES = {
    CREATE_CLIENT: 'create_client',
    SELECT_CLIENT: 'select_client',
}

export const ASSISTANT_MESSAGE_ROLES = {
    USER: 'user',
    ASSISTANT: 'assistant',
    TOOL: 'tool',
}

export const ASSISTANT_FAILURES = {
    GATEWAY_DOWN: 'gateway_down',
    SWITCHED_OFF: 'switched_off',
    FORBIDDEN: 'forbidden',
    NOT_FOUND: 'not_found',
    VALIDATION: 'validation',
    NETWORK: 'network',
    UNKNOWN: 'unknown',
}
